import { Container } from "./styles";
import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import boostrapIcon from "../../assets/bootstrap-icon.svg";
// import nextjs from "../../assets/nextjs.svg";
import python from "../../assets/python.svg";
import mysqlIcon from "../../assets/mysql-icon.svg";
import java from "../../assets/java.svg";
import vscodeIcon from "../../assets/vscode-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

// Type assertion for ScrollAnimation
const AnimatedScroll = ScrollAnimation as any;

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <AnimatedScroll animateIn="fadeInLeft">
          <h2>About me</h2>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            Hi there! I'm Muzzamal Rashid, a dedicated Software Quality
            Assurance Engineer with 5 years of experience in ensuring software
            quality for leading Canadian companies.
          </p>
        </AnimatedScroll>
        <AnimatedScroll
          animateIn="fadeInLeft"
          delay={0.2 * 1000}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
        >
          <p>
            I specialize in manual testing, test plan development, bug
            resolution, and have foundational knowledge in automated testing.
            Experienced in Agile/Scrum environments and proficient with DevOps
            tools.
          </p>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
            I'm committed to delivering high-quality products and eager to
            expand my expertise in automation. Strong skills in functional
            testing, integration testing, regression testing, and UAT testing.
          </p>
        </AnimatedScroll>
        <AnimatedScroll animateIn="fadeInLeft" delay={550}>
          <div className="experience">
            <h3>Work Experience:</h3>
            <h4>Software Quality Assurance Engineer</h4>
            <p>Phenologix | 09/2020 - 02/2026 | Lahore, Pakistan</p>
            <p>
              QA Lead, ensuring successful launch with zero bugs. Increased test
              coverage by 50%, reducing production bugs.
            </p>
            <br />
            <h4>WordPress Developer</h4>
            <p>Bizlinx Consultants | 02/2020 - 08/2020 | Lahore, Pakistan</p>
            <p>
              Provided support and maintenance for client websites. Designed and
              developed responsive WordPress websites.
            </p>
          </div>
        </AnimatedScroll>

        <AnimatedScroll animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </AnimatedScroll>
        <div className="hard-skills">
          <div
            className="hability"
            title="Python - Primary language for test automation and scripting"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={python} alt="Python" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="SQL - Database testing and data validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.11 * 1000}>
              <img src={mysqlIcon} alt="SQL" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Java - Enterprise testing frameworks and automation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={java} alt="Java" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="JavaScript - Web testing and frontend automation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="TypeScript - Robust test automation and type safety"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="TypeScript" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Node.js - API testing and backend automation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.15 * 1000}>
              <img src={nodeIcon} alt="Node.js" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="React - Frontend testing and component validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.16 * 1000}>
              <img src={reactIcon} alt="React" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="VS Code - Development environment and testing tools"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.17 * 1000}>
              <img src={vscodeIcon} alt="VS Code" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="HTML - Web testing and markup validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.18 * 1000}>
              <img src={htmlIcon} alt="HTML" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="CSS - UI testing and styling validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={cssIcon} alt="CSS" />
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Bootstrap - Responsive testing and UI frameworks"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.2 * 1000}>
              <img src={boostrapIcon} alt="Bootstrap" />
            </AnimatedScroll>
          </div>
        </div>

        <AnimatedScroll animateIn="fadeInLeft" delay={0.5 * 1000}>
          <h3>QA Testing Skills:</h3>
        </AnimatedScroll>
        <div className="hard-skills">
          <div
            className="hability"
            title="Functional Testing - Comprehensive functional test execution"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.22 * 1000}>
              <i
                className="fas fa-vial"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Unit Testing - Individual component testing"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.23 * 1000}>
              <i
                className="fas fa-cogs"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Integration Testing - System integration validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.24 * 1000}>
              <i
                className="fas fa-puzzle-piece"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Smoke Testing - Initial system validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.25 * 1000}>
              <i
                className="fas fa-fire"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Regression Testing - Post-change validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.26 * 1000}>
              <i
                className="fas fa-undo"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="UAT Testing - User acceptance validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.27 * 1000}>
              <i
                className="fas fa-user-check"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Selenium WebDriver - Automated testing framework"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.28 * 1000}>
              <i
                className="fas fa-robot"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Test Case Documentation - Comprehensive test planning"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.29 * 1000}>
              <i
                className="fas fa-file-alt"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Bug Reporting - Defect tracking and management"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.3 * 1000}>
              <i
                className="fas fa-bug"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="MongoDB - Database testing and validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.31 * 1000}>
              <i
                className="fas fa-database"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Agile/Scrum - Agile methodology implementation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.32 * 1000}>
              <i
                className="fas fa-tasks"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Azure DevOps - CI/CD and project management"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.33 * 1000}>
              <i
                className="fas fa-cloud"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
          <div
            className="hability"
            title="Postman - API testing and validation"
          >
            <AnimatedScroll animateIn="fadeInUp" delay={0.34 * 1000}>
              <i
                className="fas fa-paper-plane"
                style={{ fontSize: "2.5rem", color: "#23ce6b" }}
              ></i>
            </AnimatedScroll>
          </div>
        </div>
      </div>
      <div className="about-image">
        <AnimatedScroll animateIn="fadeInRight" delay={0.21 * 1000}>
          <img src="/Images/my-pic.png" alt="Muzzamal Rashid" />
        </AnimatedScroll>
      </div>
    </Container>
  );
}
